import React from "react"
import PropTypes from "prop-types"
import Radium from "higher-order-components/configured-radium/"
import { AnimatedCheckIcon } from "containers"

/**
 * Renders a set of background images
 * @param {object} props - Component props
 * @param {String} props.color - hex String
 * @param {Boolean} props.active - render in active state
 * @param {Boolean} props.hover - render in hover state
 * @returns {ReactElement} React Component
 */
const HexIcon = props => (
  <div style={styles.base} data-test="hex-icon">
    <div
      style={[
        styles.innerCircle,
        props.hover ? styles.hover : styles.inactive,
        props.active ? styles.active : "",
        { backgroundColor: props.color }
      ]}>
      {props.active && <div style={styles.shade} />}
      {props.active && <AnimatedCheckIcon color={props.color} />}
    </div>
  </div>
)

HexIcon.propTypes = {
  active: PropTypes.bool,
  hover: PropTypes.bool,
  color: PropTypes.string
}

export default Radium(HexIcon)

const styles = {
  base: {
    pointerEvents: "none",
    width: "2.1em",
    height: "2.1em",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundSize: "50%",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    position: "relative",
    backgroundColor: "#e7e7e7",
    boxShadow: "inset 0 1px 1px rgba(0, 0, 0, .2)"
  },
  innerCircle: {
    borderRadius: "50%",
    overflow: "hidden",
    transition: "height .125s, width .125s",
    border: "1px solid rgba(0, 0, 0, .1)",
    boxSizing: "content-box"
  },
  hover: {
    width: "2em",
    height: "2em"
  },
  active: {
    width: "2em",
    height: "2em",
    zIndex: 1
  },
  inactive: {
    width: "1em",
    height: "1em"
  },
  shade: {
    position: "relative",
    top: "50%",
    left: 0,
    width: "100%",
    height: "50%",
    background: "rgba(0, 0, 0, .1)",
    pointerEvents: "none"
  }
}



// WEBPACK FOOTER //
// ./src/components/icons/hex-icon/index.jsx